module.exports = __webpack_public_path__ + "static/media/official.1798a36.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/wolves/official.mp4
// module id = 8rZl
// module chunks = 1